import Request from ".";
import { ApiRoutes } from "../constants";

// Get User Waba Details
export const getUserWabaDetailsApi = async (formData) => {
  try {
    const res = Request.post(ApiRoutes.GET_USER_WABA_DETAILS, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Get User Waba phone numbers
export const getUserWabaPhoneNumbersApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.GET_USER_WABA_PHONE_NUMBERS,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Import Customers
export const importCustomersApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.IMPORT_CUSTOMERS, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Customers
export const getCustomerListApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.GET_CUSTOMER, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Insert Customers
export const insertCustomersApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.INSERT_CUSTOMER, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Update Customers
export const updateCustomersApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.UPDATE_CUSTOMERS, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Delete Customers
export const deleteCustomersApi = async (data) => {
  try {
    const res = await Request.delete(ApiRoutes.DELETE_CUSTOMERS, { data });
    return res;
  } catch (error) {
    throw error;
  }
};

// SYNC USER WABA DEVICE
export const syncUserWaBaPhoneNumberApi = async (data) => {
  try {
    const res = await Request.post(
      ApiRoutes.SYNC_USER_WABA_PHONE_NUMBERS,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// REGISTER USER WABA DEVICE
export const registerUserWaBaPhoneNumberApi = async (data) => {
  try {
    const res = await Request.post(
      ApiRoutes.REGISTER_USER_WABA_PHONE_NUMBERS,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Dynamic Variables
export const getDynamicVariableApi = async () => {
  try {
    const res = await Request.get(ApiRoutes.GET_DYNAMIC_VARIABLES);
    return res;
  } catch (error) {
    throw error;
  }
};
export const getQuickReplyMessageListApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.GET_QUICK_REPLY_MESSAGE_LIST,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Add Dynamic Variables
export const addDynamicVariableApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.ADD_DYNAMIC_VARIABLES, formData);
    return res;
  } catch (error) {
    throw error;
  }
};
export const addQuickReplyMessageApi = async (formData) => {
  try {
    const res = await Request.post(ApiRoutes.ADD_QUICK_REPLY_MESSAGE, formData);
    return res;
  } catch (error) {
    throw error;
  }
};

// Update Dynamic Variables
export const updateDynamicVariableApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.UPDATE_DYNAMIC_VARIABLES,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const updateQuickReplyMessageApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.UPDATE_QUICK_REPLY_MESSAGE,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Delete Dynamic Variables
export const deleteDynamicVariableApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.DELETE_DYNAMIC_VARIABLES,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const deleteQuickReplyMessageApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.DELETE_QUICK_REPLY_MESSAGE,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const insertCustomerNoteApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.INSERT_CUSTOMER_NOTE, data);
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Meta Dashboard Device Wise Counter
export const metaDashboardDeviceCounterApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.META_DASHBOARD_DEVICE_COUNTER_API,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Meta Dashboard Device Wise Counter
export const metaDashboardChatCounterApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.META_DASHBOARD_CHAT_COUNTER_API,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Send Receive Message report
export const getSendReceiveMessageReportApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.GET_SEND_RECEIVE_MESSAGE_REPORT,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Send Receive Message report
export const getTagWiseCustomerReportApi = async (formData) => {
  try {
    const res = await Request.post(
      ApiRoutes.GET_TAG_WISE_CUSTOMER_REPORT,
      formData
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const getCustomerNoteApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.GET_CUSTOMER_NOTE, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerNoteApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.UPDATE_CUSTOMER_NOTE, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerNoteApi = async (data) => {
  try {
    const res = await Request.delete(ApiRoutes.DELETE_CUSTOMER_NOTE, { data });
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Meta Dashboard Free Conversation Analytics Report Counter
export const metaDashboardFreeConversationReportApi = async (data) => {
  try {
    const res = await Request.post(
      ApiRoutes.META_DASHBOARD_FREE_CONVERSATION_REPORT,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Selected Waba Business Details
export const getSelectedWabaBusinessDetailsApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.GET_SINGLE_WABA_DETAIL, data);
    return res;
  } catch (error) {
    throw error;
  }
};
